import { render, staticRenderFns } from "./MultiLayoutList.vue?vue&type=template&id=5587f5d2"
import script from "./MultiLayoutList.vue?vue&type=script&lang=js"
export * from "./MultiLayoutList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports